$(function(){
    if (!Cookies.get('c1')) {
      $('.js-cookie-banner').fadeIn();
      $('.js-cookie').one('click',
          function(elem){
              $.ajax({
                  type: "POST",
                  url: '/api/v1/cookies',
                  headers: {
                      'X-CSRFToken': csrftoken
                  },
                  data: {},
                  success: function(){
                      $('.js-cookie-banner').fadeOut();
                      // TweenMax.to($(".js-cookie-banner"), 1.3, {
                      //     display: "none",
                      //     y: 32,
                      //     opacity: "0",
                      //     ease:Power3.easeOut,
                      // }, 0.3);
                      // toastr.success('Modification saved');
                  },
                  error: function(xhr) {
                      // N)
                      // toastr.warning(xhr.responseJSON);
                  }
              })

      });
    }
});
